module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    attrs: {
      "centered": "",
      "color": "transparent",
      "light": "",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "#0099E1"
    }
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name,
      attrs: {
        "href": '#tab-' + tab.name,
        "id": tab.name,
        "disabled": tab.isDisabled
      }
    }, [_vm._v("\n    " + _vm._s(tab.tabName) + "\n  ")])
  }), _vm._v(" "), _c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab-item', {
      key: tab.name,
      attrs: {
        "value": 'tab-' + tab.name
      }
    }, [_c('v-card', {
      attrs: {
        "color": "transparent",
        "flat": ""
      }
    }, [_c(tab.component, {
      ref: "childComponent",
      refInFor: true,
      tag: "component",
      attrs: {
        "devices": _vm.devices
      }
    })], 1)], 1)
  }), 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ec35e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Equipments.vue
// module id = 778
// module chunks = 7